export const EditorTheme = {
  ltr: 'ltr',
  rtl: 'rtl',
  placeholder: 'editor-placeholder',
  paragraph: 'editor-paragraph',
  // --- ДОДАНО НОВИЙ РЯДОК ---
  link: 'editor-link',
};